var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 61,
    viewBox: "0 0 201 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_9263)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.077 52.8521C99.9797 54.9442 97.7855 56.3755 95.2623 56.3755C91.6416 56.3755 88.6794 53.4027 88.6794 49.769C88.6794 46.1354 91.6416 43.1625 95.2623 43.1625C97.7855 43.1625 99.9797 44.5941 101.077 46.686H105.465C104.149 42.2818 100.09 38.9785 95.2623 38.9785C89.3378 38.9785 84.6201 43.8233 84.6201 49.659C84.6201 55.6048 89.4474 60.3395 95.2623 60.3395C100.09 60.3395 104.149 57.1463 105.465 52.6319H101.077V52.8521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.516 7.15625L95.5912 15.4144L89.557 7.15625H84.9491V27.9668H89.0085V12.7718L93.2872 18.6075H97.8953L102.064 12.7718V27.9668H106.124V7.15625H101.516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.549 38.9785C136.624 38.9785 131.906 43.8233 131.906 49.659C131.906 55.4948 136.734 60.3395 142.549 60.3395C148.473 60.3395 153.19 55.4948 153.19 49.659C153.19 43.8233 148.473 38.9785 142.549 38.9785ZM142.549 56.3755C138.928 56.3755 135.966 53.4027 135.966 49.769C135.966 46.1354 138.928 43.1625 142.549 43.1625C146.169 43.1625 149.131 46.1354 149.131 49.769C149.241 53.4027 146.279 56.3755 142.549 56.3755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.716 6.82617C114.791 6.82617 110.074 11.6709 110.074 17.5067C110.074 23.4525 114.901 28.1873 120.716 28.1873C126.64 28.1873 131.358 23.3425 131.358 17.5067C131.358 11.5608 126.64 6.82617 120.716 6.82617ZM120.716 24.1133C117.095 24.1133 114.133 21.1402 114.133 17.5067C114.133 13.8731 117.095 10.9002 120.716 10.9002C124.336 10.9002 127.298 13.8731 127.298 17.5067C127.298 21.1402 124.336 24.1133 120.716 24.1133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.55 39.3086H157.25V60.119H161.309V54.0631H168.55C172.61 54.0631 175.901 50.7599 175.901 46.6859C175.791 42.6118 172.61 39.3086 168.55 39.3086ZM168.55 49.8789H161.309V43.3826H168.55C170.306 43.3826 171.732 44.8139 171.732 46.5757C171.732 48.4476 170.306 49.8789 168.55 49.8789Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.415 39.3086V60.119H113.475V43.3826H123.897V60.119H128.066V39.3086H109.415Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.379 39.3086H178.644V43.3826H186.982V60.119H191.041V43.3826H199.379V39.3086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.338 7.15625L139.367 21.3603V7.15625H135.308V27.9668H139.367L150.338 13.6527V27.9668H154.397V7.15625H150.338Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.852 5.83575C148.363 5.83575 151.106 3.52348 151.325 0H148.034C147.815 1.54152 146.498 2.5325 144.743 2.5325C142.987 2.5325 141.671 1.54152 141.451 0H138.16C138.599 3.52348 141.341 5.83575 144.852 5.83575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2262 6.82617H49.8412V60.559H63.2262V6.82617Z",
    fill: "#C00303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1774 61.0007C36.9642 61.0007 40.8448 57.1062 40.8448 52.3021C40.8448 47.4981 36.9642 43.6035 32.1774 43.6035C27.3907 43.6035 23.5101 47.4981 23.5101 52.3021C23.5101 57.1062 27.3907 61.0007 32.1774 61.0007Z",
    fill: "#F9B231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5139 6.82617H1.12903V60.5591H14.5139V6.82617Z",
    fill: "#0087C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.12903 6.82617L24.0589 39.3081H40.2963L17.3665 6.82617H1.12903Z",
    fill: "#009EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2263 6.82617L40.2966 39.3082H24.0591L46.9888 6.82617H63.2263Z",
    fill: "#E3000B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_9263"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 61,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo01);
export default __webpack_public_path__ + "static/media/logo01.3255adecf540f2c950d25f65af2f4755.svg";
export { ForwardRef as ReactComponent };